import styled from 'styled-components'

export const Heading = styled.h2`
  margin-bottom: 3rem;
  font-family: ${({ theme: { fonts } }) => fonts[0]};
  font-size: ${({ theme: { fontSizes } }) => fontSizes.medium};
  color: ${({ theme: { colors } }) => colors.royal};
`
